import type { SuperAgentRequest } from "superagent";
import request from "../../util/SuperagentUtils";
import { supplierReadyForPayoutReportEndpoints } from "../../requests/api-endpoints";
import type { PageQueryParams } from "../../types/common/Pagination";

/** Query params for the supplier ready-for-payout endpoints (the API's search criteria, sort and page params). */
interface ReadyForPayoutQuery extends PageQueryParams {
  locationId?: string;
  sortBy?: string;
  sortDir?: string;
}

/** Mirrors the API's SupplierPayoutVO. */
interface InitiatePayoutsRequest {
  supplierAccountId: string;
  transactionIds?: string[];
  locationIds?: string[];
  groupForSupplier?: boolean;
}

export const requestReadyForPayoutTransactionsForAccount = (query: ReadyForPayoutQuery): SuperAgentRequest => {
    return request.get(supplierReadyForPayoutReportEndpoints.search).query(query);
}

export const requestReadyForPayoutSummary = (query: ReadyForPayoutQuery): SuperAgentRequest => {
    return request.get(supplierReadyForPayoutReportEndpoints.summary).query(query);
}

export const getReadyForPayoutReportUrl = (searchParams: Pick<ReadyForPayoutQuery, 'locationId' | 'sortBy' | 'sortDir'>): string => {
  const { locationId, sortBy, sortDir } = searchParams;
  const queryParams = new URLSearchParams();
  if (locationId) queryParams.append("locationId", locationId);
  if (sortBy) queryParams.append("sortBy", sortBy);
  if (sortDir) queryParams.append("sortDir", sortDir);

  return `${supplierReadyForPayoutReportEndpoints.report}?${queryParams}`;
}

export const getReadyForPayoutGroupSummaryReportUrl = (searchParams: Pick<ReadyForPayoutQuery, 'locationId'>): string => {
    const { locationId } = searchParams;
    const queryParams = new URLSearchParams();
    if (locationId) queryParams.append("locationId", locationId);

    return `${supplierReadyForPayoutReportEndpoints.group}?${queryParams}`;
}

export const requestInitiatePayouts = (body: InitiatePayoutsRequest): SuperAgentRequest => {
    return request.post(supplierReadyForPayoutReportEndpoints.actions.initiatePayouts).send(body);
}